<template>
  <div>
    <router-view></router-view>
    <VisitorTabBar v-if="needToolBar && needToolBar === 'visitor'"></VisitorTabBar>
    <MeetingTabBar v-if="needToolBar && needToolBar === 'meeting'"></MeetingTabBar>
    <VisitorTaBarSh v-if="needToolBar && needToolBar === 'visitorSh'"></VisitorTaBarSh>
  </div>
</template>

<script>
import VisitorTabBar from '@/components/visitorTabBar.vue';
import MeetingTabBar from '@/components/meetingTabBar.vue';
import VisitorTaBarSh from '@/components/visitorTaBarSh.vue';
export default {
  components: { VisitorTabBar, MeetingTabBar, VisitorTaBarSh },
  data() {
    return {};
  },
  methods: {
    auth() {
      const token = sessionStorage.getItem('token');
      if (!token) {
        this.$router.push({ name: 'login' });
      }
    },
  },
  computed: {
    needAuth() {
      return this.$route.meta.auth;
    },
    needToolBar() {
      return this.$route.meta.toolBar;
    },
  },
  mounted() {
    if (this.needToolBar !== 'visitorSh') {
      this.needAuth && this.auth();
    }
  },
};
</script>

<style lang="less" scoped></style>
